import { defineStore } from 'pinia';
import Helper from '@/helpers/helper';
import ErrorHelper from '../helpers/errorManagerhelaper';
import Swal from 'sweetalert2';
import merge from 'lodash/merge';



export const useTransferStore = defineStore('transfers', {
    state: () => ({
        list: undefined,
        details: [],
        info: null
    }),
    actions: {
        setData(data) {
            this.list = data
        },

        addOne(newOne) {
            this.list ??= [];
            this.list.unshift(newOne)
        },
        updateOne(updated) {
            this.list ??= [];
            const index = this.list.findIndex(t => t.id === updated.id)
            if (index !== -1) {
                this.list[index] = merge({}, this.list[index], updated);
            } else {
                this.list.push(updated);
            }
        },

        
         removeOne(deleted) {
            this.list ??= [];
            this.list = this.list.filter(t => t.id != deleted.id) 
        },

        
        setInfo(item){
            this.info = item;
        },

        updateInfo(item) {
            this.info = merge({}, this.info, item);
        },

         getOne(id){
            this.list ??= [];
            const index = this.list.findIndex(t => t.id === id)
            if (index !== -1) {
               return this.list[index];
            }
            return null;
        },

        getOneDetails(id){
            this.list ??= [];
            const index = this.details.findIndex(t => t.id === id)
            if (index !== -1) {
               return this.details[index];
            }
            return null;
        },

          addDetail(item){
            this.details ??= [];
            const index = this.details.findIndex(t => t.id === item.id)
            if (index !== -1) {
                this.details[index] = merge({}, this.details[index], item);
            } else {
                this.details.unshift(item)
              }
              return item;
        },


     async  loadFromApi(londing=false) {
            try {
                if(londing){
                    Swal.showLoading();
                }
                const route = 'transfers/admin/list'
                const response = await fetch(Helper.route(route), Helper.requestOptionsJSON())

                if (!response.ok) {
                    const error = await ErrorHelper.handleApiError(response);
                    ErrorHelper.showError(error);
                    return;
                }
                if(londing){
                    Swal.close();
                }
                
                const data = await response.json()
                this.list = data
                return data;
            } catch (error) {
                const normalizedError = ErrorHelper.handleUnexpectedError(error);
                ErrorHelper.showError(normalizedError);
                throw normalizedError;
            }
        },

    async  loadOne(id, loading=false) {
        try {
            if(loading){
                Swal.showLoading(null);
            }
            

            const route = "transfers/" + id + "/details";
            const response = await fetch(Helper.route(route), Helper.requestOptionsJSON())

            if (!response.ok) {
                const error = await ErrorHelper.handleApiError(response);
                ErrorHelper.showError(error);
                return;
            }

            const resp = response.json();
            this.updateOne(resp);
            this.addDetail(resp);
            this.info = resp;

            if(loading){
                Swal.fire("User !", "Status successfully modified", "success");
            }

            return resp;

        } catch (error) {
                const normalizedError = ErrorHelper.handleUnexpectedError(error);
                ErrorHelper.showError(normalizedError);
                throw normalizedError;
        }
        },

    async  tryFinish(id, loading=true) {
        try {
            if(loading){
                Swal.showLoading(null);
            }
            

            const route = "transfers/" + id + "/feexpay/manual-start-payout";
            const response = await fetch(Helper.route(route), Helper.requestOptionsJSON())

            if (!response.ok) {
                const error = await ErrorHelper.handleApiError(response);
                ErrorHelper.showError(error);
                return;
            }

            const resp = response.json();
            this.updateOne(resp);
            this.addDetail(resp);
            this.info = merge({}, this.info, resp);


            if(loading){
                Swal.fire("Transfer !", "Transfer successfully finished", "success");
            }

            return resp;

        } catch (error) {
                const normalizedError = ErrorHelper.handleUnexpectedError(error);
                ErrorHelper.showError(normalizedError);
                throw normalizedError;
        }
        },

    async  toManual(id, loading=true) {
        try {
            if(loading){
                Swal.showLoading(null);
            }
            

            const route = "transfers/" + id + "/move-to-manual";
            const response = await fetch(Helper.route(route), Helper.requestOptionsJSON())

            if (!response.ok) {
                const error = await ErrorHelper.handleApiError(response);
                ErrorHelper.showError(error);
                return;
            }
 
            const resp = response.json();
            this.updateOne(resp);
            this.addDetail(resp);
            this.info = merge({}, this.info, resp);

            if(loading){
                Swal.fire("Transfer !", "Transfer successfully moov to manual", "success");
            }

            return resp;

        } catch (error) {
                const normalizedError = ErrorHelper.handleUnexpectedError(error);
                ErrorHelper.showError(normalizedError);
                throw normalizedError;
        }
        },





    },
    
    persist: {
        storage: sessionStorage,
        key: `${Helper.env}__transfers`
        
    },
})

